module.exports = __webpack_public_path__ + "assets/img/40@3x.1f43f1d1.png";